const main = resolve => require(['@/views/index/index.vue'], resolve) // 主页
const messageCenter = (resolve) => require(['@/views/messageCenter/index.vue'], resolve) // 消息中心

export default [
  {
    path: '/index',
    component: main,
    children: [
      // 消息中心
      {
        name: 'messageCenter',
        path: '/aq/messageCenter',
        alias: ['/aq/messageCenter.htm'],
        component: messageCenter
      }
    ]
  }
]
